// src/pages/ContactUs.js
import React, { useState } from "react";
import "./ContactUs.css";

function ContactUs() {
  const [formResponse, setFormResponse] = useState("");
  const [contactFormData, setContactFormData] = useState({
    name: "",
    email: "",
    phone: "",
    smsConsent: false,
    message: "",
  });

  // Handle changes
  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Submit form
  const handleContactSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", contactFormData.name);
    data.append("email", contactFormData.email);
    data.append("phone", contactFormData.phone);
    data.append("smsConsent", contactFormData.smsConsent);
    data.append("message", contactFormData.message);

    fetch("php/mail.php", {
      method: "POST",
      body: data,
    })
      .then((response) => response.text())
      .then((responseText) => {
        setFormResponse(responseText);
        setContactFormData({
          name: "",
          email: "",
          phone: "",
          smsConsent: false,
          message: "",
        });
      })
      .catch(() => {
        setFormResponse(
          "There was an error submitting your message. Please try again."
        );
      });
  };

  return (
    <div className="contact-page">
      <main className="main-content">
        <h1>Contact Greenview San Diego Hardscape</h1>

        <div className="company-info">
          <p>
            <strong>
              Greenview San Diego Hardscape — Licensed C-27 Landscape Contractor
            </strong>
          </p>

          <p>
            CSLB License: <strong>#1141945</strong> — Classification: C-27
            Landscape Contractor
          </p>

          <p>Service Area: San Diego County, California</p>

          <p>
            Phone:{" "}
            <a href="tel:+16194649153">(619) 464-9153</a>
          </p>

          <div
            className="quick-actions"
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              marginTop: "8px",
            }}
          >
            <a
              className="qa-btn"
              href="tel:+16194649153"
              aria-label="Call Greenview San Diego Hardscape"
            >
              Call Now
            </a>

            <a
              className="qa-btn secondary"
              href="https://maps.google.com/?q=La%20Mesa%2C%20CA"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Service area map"
            >
              Service Area Map
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleContactSubmit}>
          <label htmlFor="name">Your Name</label>
          <input
            id="name"
            name="name"
            placeholder="Your Name"
            required
            value={contactFormData.name}
            onChange={handleContactChange}
          />

          <label htmlFor="email">Your Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="Your Email"
            required
            value={contactFormData.email}
            onChange={handleContactChange}
          />

          <label htmlFor="phone">Phone Number</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            placeholder="Your Phone Number"
            required
            value={contactFormData.phone}
            onChange={handleContactChange}
            inputMode="tel"
          />

          {/* SMS Consent */}
          <div className="checkbox-group">
            <input
              id="smsConsent"
              name="smsConsent"
              type="checkbox"
              checked={contactFormData.smsConsent}
              onChange={handleContactChange}
            />
            <label htmlFor="smsConsent" className="checkbox-label">
              By checking this box, you agree to receive SMS text messages from
              Greenview San Diego Hardscape regarding your request. Reply STOP to
              opt out at any time. Reply HELP for customer care contact
              information. Message and data rates may apply. Message frequency
              may vary. View our{" "}
              <a
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Terms and Conditions
              </a>
              .
            </label>
          </div>

          <label htmlFor="message">Your Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Tell us about your project..."
            rows="5"
            required
            value={contactFormData.message}
            onChange={handleContactChange}
          ></textarea>

          <button type="submit" className="send-btn">
            Send Message
          </button>
        </form>

        {formResponse && (
          <div className="form-response">{formResponse}</div>
        )}
      </main>
    </div>
  );
}

export default ContactUs;